const Lang = localStorage.getItem('Lang')
export const authHeaderAPI = (): { Authorization?: string; Lang: string } => {
  const user =
    localStorage.getItem('user') && JSON.parse(localStorage.getItem('user') as string)
      ? JSON.parse(localStorage.getItem('user') as string)
      : null
  if (user && user.Token) {
    return { Authorization: `Bearer ${user.Token}`, Lang: Lang || 'EN' }
  }
  return { Lang: Lang || 'EN' }
}
